import { supabase } from './supabaseClient';

export const UPLOAD_IMAGE_BUCKET =
  process.env.REACT_APP_SUPABASE_UPLOAD_BUCKET
  || process.env.REACT_APP_SUPABASE_ADS_BUCKET
  || 'admin-images';

export const CHECKLIST_ISSUES_BUCKET = 'checklist-issues';

const MAX_BYTES = 10 * 1024 * 1024;

/**
 * Upload an image file to Supabase Storage and return its public URL.
 * @param {File} file
 * @param {{ bucket?: string, folder?: string }} [opts]
 */
export async function uploadImageToSupabase(file, opts = {}) {
  if (!file) throw new Error('Dosya seçilmedi.');
  if (!file.type?.startsWith('image/')) {
    throw new Error('Yalnızca görsel dosyası yükleyebilirsiniz.');
  }
  if (file.size > MAX_BYTES) {
    throw new Error('Görsel boyutu en fazla 10MB olabilir.');
  }

  const bucket = opts.bucket || UPLOAD_IMAGE_BUCKET;
  const folder = (opts.folder || 'uploads').replace(/^\/+|\/+$/g, '');

  const { data: authData, error: authErr } = await supabase.auth.getUser();
  if (authErr) throw authErr;

  const uid = authData?.user?.id || 'anonymous';
  const ext = (file.name.split('.').pop() || 'jpg').toLowerCase();
  const safeExt = /^[a-z0-9]+$/.test(ext) ? ext : 'jpg';
  const path = `${folder}/${uid}/${Date.now()}-${Math.random().toString(36).slice(2, 8)}.${safeExt}`;

  const { error: uploadErr } = await supabase.storage
    .from(bucket)
    .upload(path, file, { cacheControl: '3600', upsert: false });
  if (uploadErr) throw uploadErr;

  const { data } = supabase.storage.from(bucket).getPublicUrl(path);
  const publicUrl = data?.publicUrl;
  if (!publicUrl) {
    throw new Error('Görsel yüklendi ama public URL oluşturulamadı.');
  }
  return publicUrl;
}

export function formatImageUploadError(err, bucket = UPLOAD_IMAGE_BUCKET) {
  const msg = err?.message || 'Görsel yüklenemedi.';
  if (/bucket/i.test(msg) && /not found/i.test(msg)) {
    return `Storage bucket bulunamadı: ${bucket}. sql/65_admin_images_storage.sql dosyasını Supabase'de çalıştırın.`;
  }
  if (/row-level security|permission|not allowed|unauthorized|forbidden/i.test(msg)) {
    return 'Görsel yükleme yetkisi yok. Storage policy (INSERT) kontrol edin.';
  }
  return msg;
}
